import gql from 'graphql-tag';

export const getVisitorCustomFieldConfigs = gql`
  query GetVisitorCustomFieldConfigs($organizationId: String!) {
    visitorCustomFieldConfigs(organizationId: $organizationId) {
      id
      organizationId
      fieldKey
      fieldName
      fieldType
      isEnabled
      options {
        displayText
        value
      }
      placeholder
      validationRegex
      createdAtDatetime
      updatedAtDatetime
      createdByUserId
      updatedByUserId
    }
  }
`;
